/* globals angular, _ */
(function() {
  'use strict';

  function ReverseCancelCtrl ($scope, $rootScope, $state, $uibModalInstance, Historico, id) {

    var vm = this;

    vm.id = id;

    vm.confirm = function () {
        $uibModalInstance.close({cancelar: true});
    };

    vm.closePanel = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReverseCancelCtrl', ReverseCancelCtrl);
}());
